import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-缩小",
  "use": "icon-缩小-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol viewBox=\"0 0 21 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-缩小\">\r\n<path d=\"M13.4167 9.58268H6.75002M18.8334 18.3327L15.9167 15.416M18 9.58268C18 13.9549 14.4556 17.4993 10.0834 17.4993C5.7111 17.4993 2.16669 13.9549 2.16669 9.58268C2.16669 5.21043 5.7111 1.66602 10.0834 1.66602C14.4556 1.66602 18 5.21043 18 9.58268Z\" stroke=\"#828282\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol